const creditCardManagement = {
  removeCard: 'Quitar',
};

export default creditCardManagement;
